import React from 'react';

const FulfillmentPolicy = () => {
  return (
    <div className="fulfillment-policy">
      <div className="box-top-panel">
        <h1>Enhanced AI, Corp. Refund and Fulfillment Policy</h1>
      </div>
      <div className="base-outlet-content base-outlet-content--plaintext">
        <h2>Digital Products and Services</h2>
        <strong>FluxPrompt Platform Access</strong>
        <ul>
          <li>
            A 30-day money-back guarantee is provided for all new FluxPrompt
            subscriptions.
          </li>
          <li>
            Refund requests must be submitted within 30 days of purchase through
            our customer support portal.
          </li>
          <li>
            Access to the platform will be immediately revoked upon refund
            approval.
          </li>
        </ul>

        <h2>Service Engagements</h2>
        <strong>Consulting and Professional Services</strong>
        <ul>
          <li>
            Services can be canceled within 24 hours of purchase for a full
            refund.
          </li>
          <li>
            For ongoing services, unused portions may be eligible for a prorated
            refund.
          </li>
          <li>
            Custom project work requires written cancellation notice and may
            incur partial charges for work completed.
          </li>
        </ul>

        <h2>General Terms</h2>
        <strong>Refund Processing</strong>
        <ul>
          <li>
            All approved refunds will be processed within 5-7 business days.
          </li>
          <li>
            Refunds will be issued to the original payment method used for
            purchase.
          </li>
          <li>
            Store credit may be offered as an alternative to monetary refunds.
          </li>
        </ul>

        <strong>Eligibility Requirements</strong>
        <ul>
          <li>
            A valid proof of purchase is required for all refund requests.
          </li>
          <li>
            Accounts with a history of excessive refund requests may be subject
            to review.
          </li>
          <li>
            Enhanced AI, Corp. reserves the right to modify this policy at any
            time.
          </li>
        </ul>

        <strong>Contact Information</strong>
        <p>
          Enhanced AI, Corp. <br />
          1225 East Fort Union Blvd <br />
          Cottonwood Heights, UT 84047 <br />
          Email: support@enhanced.ai
        </p>

        <h2>Exclusions</h2>
        <ul>
          <li>
            Enterprise-level customizations and implementations are subject to
            separate contractual agreements.
          </li>
          <li>
            Special promotional offers or discounted purchases may have
            different refund terms.
          </li>
          <li>
            Time-sensitive or limited availability products may be marked as
            final sale.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FulfillmentPolicy;
